import { type ReactElement } from 'react'
import type MaTab from '../models/MaTab'
import useIsMobile from '../hooks/useIsMobile'
import MaAccordion from './MaAccordion'
import MaTabs from './MaTabs'

interface MaDetailsTabsProps {
  readonly tabs: MaTab[]
  readonly activeTab: string
  readonly onSelectTab?: (tabKey: string) => void
}

function MaDetailsTabs ({
  tabs,
  activeTab,
  onSelectTab
}: MaDetailsTabsProps): ReactElement {
  const isMobile = useIsMobile()

  return isMobile ? (
    <MaAccordion tabs={tabs} activeTab={activeTab} onSelectTab={onSelectTab} />
  ) : (
    <MaTabs
      tabs={tabs}
      activeTab={activeTab}
      onSelectTab={onSelectTab}
    />
  )
}

export default MaDetailsTabs
